import _ from 'lodash'

import {
  CLEAR_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS,
  CLEAR_CHECKLIST_ERRORS_SUCCESS,
  CLEAR_CHECKLIST_PROJECT_SUCCESS,
  CLEAR_CHECKLIST_RESULTS_SUCCESS,
  CLEAR_CHECKLIST_SUCCESS,
  CREATE_CHECKLIST_FAILURE,
  CREATE_CHECKLIST_SUCCESS,
  LIST_CHECKLIST_PROJECTS_FAILURE,
  LIST_CHECKLIST_PROJECTS_SUCCESS,
  LIST_CHECKLIST_RESULTS_FAILURE,
  LIST_CHECKLIST_RESULTS_SUCCESS,
  LIST_CHECKLISTS_FAILURE,
  LIST_CHECKLISTS_SUCCESS,
  READ_CHECKLIST_FAILURE,
  READ_CHECKLIST_PROJECT_FAILURE,
  READ_CHECKLIST_PROJECT_SUCCESS,
  READ_CHECKLIST_SUCCESS,
  SET_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS,
  SET_CHECKLIST_DAILY_CURRENT_FIELD_SUCCESS,
  SET_CHECKLIST_ERRORS_SUCCESS,
  SET_CHECKLIST_PROJECT_SUCCESS,
  SET_CHECKLIST_RESULTS_FIELD_SUCCESS,
  UPDATE_CHECKLIST_FAILURE,
  UPDATE_CHECKLIST_RESULTS_FAILURE,
  UPDATE_CHECKLIST_RESULTS_SUCCESS,
  UPDATE_CHECKLIST_SUCCESS,
} from '../actions/checklist'

const checklist = (state = { results: {} }, action) => {
  switch (action.type) {
    case CREATE_CHECKLIST_SUCCESS:
    case UPDATE_CHECKLIST_SUCCESS:
      return state
    case READ_CHECKLIST_SUCCESS:
      return {
        ...state,
        ...action.data
      }
    case LIST_CHECKLISTS_SUCCESS:
      return {
        ...state,
        ...action.data
      }
    case CLEAR_CHECKLIST_SUCCESS:
      return _.omit(state, 'current')
    case READ_CHECKLIST_PROJECT_SUCCESS:
      return {
        ...state,
        project: action.data.project,
        projectVersion: 1
      }
    case LIST_CHECKLIST_PROJECTS_SUCCESS:
      return {
        ...state,
        projects: {
          ...action.data
        }
      }
    case LIST_CHECKLIST_RESULTS_SUCCESS:
      return {
        ...state,
        results: {
          ...state.results,
          checklistId: action.data.checklistId,
          projectId: action.data.projectId,
          list: action.data.list
        }
      }
    case UPDATE_CHECKLIST_RESULTS_SUCCESS:
      return state
    case CLEAR_CHECKLIST_RESULTS_SUCCESS:
      return {
        ...state,
        results: {}
      }
    case CLEAR_CHECKLIST_PROJECT_SUCCESS:
      return _.omit(state, ['project', 'projectVersion'])
    case SET_CHECKLIST_PROJECT_SUCCESS:
      return {
        ...state,
        project: action.data.project,
        projectVersion: state.projectVersion ? state.projectVersion + 1 : 1
      }
    case SET_CHECKLIST_ERRORS_SUCCESS:
      return {
        ...state,
        ...action.data
      }
    case CLEAR_CHECKLIST_ERRORS_SUCCESS:
      return _.omit(state, 'errors')
    case SET_CHECKLIST_RESULTS_FIELD_SUCCESS:
      return {
        ...state,
        results: {
          ...state.results,
          [action.data.field]: action.data.value
        }
      }
    case SET_CHECKLIST_DAILY_CURRENT_FIELD_SUCCESS:
      return {
        ...state,
        results: {
          ...state.results,
          current: { ...state.results.current, [action.data.field]: action.data.value }
        }
      }
    case SET_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS:
      return {
        ...state,
        results: {
          ...state.results,
          current: { ...state.results.current, defectAddErrors: action.data.errors }
        }
      }
    case CLEAR_CHECKLIST_DAILY_CURRENT_ERRORS_SUCCESS:
      return _.omit(state, 'results.current.defectAddErrors')
    case CREATE_CHECKLIST_FAILURE:
    case UPDATE_CHECKLIST_FAILURE:
    case READ_CHECKLIST_FAILURE:
    case LIST_CHECKLISTS_FAILURE:
    case READ_CHECKLIST_PROJECT_FAILURE:
    case LIST_CHECKLIST_PROJECTS_FAILURE:
    case LIST_CHECKLIST_RESULTS_FAILURE:
    case UPDATE_CHECKLIST_RESULTS_FAILURE:
    default:
      return state
  }
}

export default checklist


// WEBPACK FOOTER //
// ./src/reducers/checklist.js